import * as _ from 'lodash';

import {
  isAreaPoint,
  type SafeAreaPoint,
  type SafePoint,
} from '../PanelRunsLinePlot/componentOutliers/types';

function isInBounds(v: number, min: number, max: number) {
  // Handle non-finite values (Infinity, -Infinity, NaN, or string representations)
  // Convert to number first to handle string values like "Infinity"
  const numV = Number(v);
  if (!Number.isFinite(numV)) {
    return false;
  }
  return numV >= min && numV <= max;
}

export function makeClampPoint(
  [lowerBound, upperBound]: [number, number],
  [expandedLowerBound, expandedUpperBound]: [number, number]
) {
  return (pt: SafePoint | SafeAreaPoint) => {
    const areaPoint = isAreaPoint(pt);
    const y = Number(pt.y);
    // we don't need to get a new reference if we're not clamping
    if (!areaPoint && isInBounds(y, lowerBound, upperBound)) {
      return pt;
    }
    if (
      areaPoint &&
      isInBounds(y, lowerBound, upperBound) &&
      isInBounds(pt.y0 as number, lowerBound, upperBound)
    ) {
      return pt;
    }

    const clampedY = isFinite(pt.y)
      ? _.clamp(y, expandedLowerBound, expandedUpperBound)
      : y === Infinity
        ? upperBound
        : y === -Infinity || isNaN(y)
          ? lowerBound
          : pt.y;

    if (!areaPoint) {
      return {
        ...pt,
        y: clampedY,
      } as SafePoint;
    }

    const y0 = Number(pt.y0);
    const clampedY0 = isFinite(y0)
      ? _.clamp(y0 as number, expandedLowerBound, expandedUpperBound)
      : y0 === Infinity
        ? upperBound
        : y0 === -Infinity || isNaN(y0)
          ? lowerBound
          : pt.y0;

    const r = {
      ...pt,
      y: clampedY,
      y0: clampedY0,
    } as SafeAreaPoint;

    return r;
  };
}
